import dayjs from 'dayjs';
import React, { useRef } from 'react';
import { TbCamera, TbPencil, TbUserEdit } from 'react-icons/tb';
import { useAuthContext } from '../../../context/authContext';
import { useEmployeeContext } from '../../../context/employee-context';
import useSnackbar from '../../../hook/use-snakbar';
import { Col, Dialog, FabButton, InputField, Row, SelectField } from '../../../ppui';
import { subtractYearsFromDate } from '../../../utils/common';
import { PhotoIcon, PhotoUpload } from '../../style';
import { EMPLOYEE_DETAILS_MODAL, EMPLOYEE_FORM_FIELDS, EMPLOYEE_INFORMATION_MODAL, EMPLOYEE_PERMANENT_ADDRESS_MODAL, EMPLOYEE_PRESENT_ADDRESS_MODAL, EMPLOYEE_PROFILE_MODAL } from './profile-constant';

const ProfileDialog = ({
  Presentaddress,
  PresentaddressModalClose,
  PermanentaddressModalClose,
  Permanentaddress,
  PersonalInformationModalClose,
  PersonalInformation,
  EmployeedetailsModalClose,
  Employeedetails,
  getInputFieldProps,
  employeeProfileInput,
  handleClick,
  createFormUpdateLoading,
  employeeProfile,
  employeeProfileModalClose,
  setEmployeeProfileInput,
  // handleFileChange,
  previewURL,
  setSelectedFile,
  setPreviewURL,
}) => {
  const { orgDetails } = useAuthContext()
  const {
    employeeInfo: imployeeInfoFromDB,
    stateList,
    branchList,
    departmentList,
    designationList,
    employmentTypeList,
    shiftManagement,
    // isHaveExitFormlity
  } = useEmployeeContext() || {};
  // const { showToastMessage } = useToast();
  const {
    openSnackbar,
  } = useSnackbar();
  const fileInputRef = useRef()
  const getStatusOptions = (status) => {
    return [
      { id: "active", name: "Active" },
      { id: "inactive", name: "Inactive"},
      // { id: "inactive", name: "Inactive",disabled:!isHaveExitFormlity },
      { id: "onboarding", name: "Onboarding", disabled: status === "active" },
    ];
  };

  return (
    <>
      {/* Employee profile Edit Modal  */}
      <Dialog
        title="Employee Profile"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={employeeProfile}
        onClose={employeeProfileModalClose}
        onSubmit={() => handleClick(undefined, EMPLOYEE_PROFILE_MODAL)}
        btnLoading={createFormUpdateLoading}
        buttonName={employeeProfileInput?.employee_id ? "Update" : "Submit"}
        separator
      >
        <Row rowGap alignItem="center" >
          <Col sm={"auto"}>
            <PhotoUpload
            >
              {!previewURL &&
                <TbUserEdit />
              }
              <input
                type="file"
                id="image"
                name="image"
                // onChange={handleFileChange}
                onChange={(event) => {
                  const file = event.target.files[0];
                  if (file) {
                    const maxSizeInBytes = 2 * 1024 * 1024;
                    if (file.size > maxSizeInBytes) {
                      openSnackbar({
                        message: "File size should not exceed 2 MB.",
                        color: "danger",
                      });
                      return;
                    }
                    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

                    if (!allowedTypes.includes(file.type)) {
                      openSnackbar({
                        message: "Only JPG and PNG files are allowed.",
                        color: "danger",
                      });
                      return; // Stop if the file type is not allowed
                    }

                    setSelectedFile(file);
                    setPreviewURL(URL.createObjectURL(file)); // Create a preview URL

                    setEmployeeProfileInput((prevUser) => ({
                      ...prevUser,
                      logo: file,
                    }));
                  }
                }}
                ref={fileInputRef}
                accept=".jpg, .jpeg, .png, image/jpeg, image/png"
                hidden
              />
              {/* {imployeeInfoFromDB?.logo && <img src={imployeeInfoFromDB?.logo} alt="img-logo" />} */}
              {previewURL && <img src={previewURL} alt="img-logo" />}
              <PhotoIcon onClick={() => {
                if (fileInputRef.current) {
                  fileInputRef.current.click();
                }
              }}>
                <FabButton size="xs" variant="contained" color="primary" icon={imployeeInfoFromDB?.logo ? <TbPencil /> : <TbCamera />} />
              </PhotoIcon>
            </PhotoUpload>
          </Col>
          <Col>
            <Row rowGap >
              <Col sm={12} md={6}>
                <InputField
                  {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.first_name.name)}
                />
              </Col>
              <Col sm={12} md={6}>
                <InputField
                  {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.last_name.name)}
                />
              </Col>
              <Col sm={12} md={6}>
                <InputField
                  {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.email.name)}
                />
              </Col>
              <Col sm={12} md={6}>
                <InputField
                  {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.phone.name)}
                />
              </Col>
              <Col sm={12} md={6}>
                <InputField
                  {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.alternative_phone.name)}
                />
              </Col>

              <Col sm={12} md={6}>
                <SelectField
                  {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.status.name)}
                  options={getStatusOptions(imployeeInfoFromDB?.status)}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Dialog>
      {/* Employee Details Edit Modal */}
      <Dialog
        title="Employee Details"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={Employeedetails}
        onClose={EmployeedetailsModalClose}
        onSubmit={() => handleClick(undefined, EMPLOYEE_DETAILS_MODAL)}
        btnLoading={createFormUpdateLoading}
        buttonName={employeeProfileInput?.employee_id ? "Update" : "Submit"}
      >
        <Row rowGap mb={20}>
          <Col sm={12} md={6}>
            <SelectField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.employment_type.name)}
              options={employmentTypeList}
            />
          </Col>
          <Col sm={12} md={6}>
            <SelectField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.salary_type.name)}
            />
          </Col>


          {employeeProfileInput.employment_type === "probationary" &&
            // employeeProfileInput.employment_status === "provisionperiod" && 
            <Col sm={12} md={6}>
              <InputField
                {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.provision_period_days.name)}

              />
            </Col>}
          <Col sm={12} md={6}>
            <InputField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.join_date.name)}
              min={dayjs(orgDetails?.date_of_org).format("YYYY-MM-DD")}
              valueSinc
              onKeyDown={e => e.preventDefault()}
            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.branch_id.name)}
              options={branchList}
            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.department_id.name)}
              options={departmentList}
              onChange={(e) => {
                // Clear designation when department changes
                setEmployeeProfileInput(prev => ({
                  ...prev,
                  department_id: e,
                  designation_id: '' // Reset designation
                }));
              }}

            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.designation_id.name)}
              // options={designationList}
              options={designationList.filter(
                (designation) =>
                  designation.dept_id === employeeProfileInput.department_id
              )}

            />
          </Col>

          {shiftManagement &&
            <Col sm={12} md={6}>
              <SelectField
                {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.shift_type.name)}

              />
            </Col>}

          {employeeProfileInput.employment_type === "contractual" &&
            <>
              <Col sm={12} md={6}>
                <InputField
                  {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.contract_start.name)}
                  valueSinc
                  onKeyDown={e => e.preventDefault()}
                  min={employeeProfileInput.join_date}
                />
              </Col>

              <Col sm={12} md={6}>
                <InputField
                  {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.contract_end.name)}
                  valueSinc
                  onKeyDown={e => e.preventDefault()}
                  min={employeeProfileInput.contract_start}
                />
              </Col>
            </>}

        </Row>
      </Dialog>
      {/* Personal Information Edit Modal */}
      <Dialog
        title="Personal Information"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={PersonalInformation}
        onClose={PersonalInformationModalClose}
        onSubmit={() => handleClick(undefined, EMPLOYEE_INFORMATION_MODAL)}
        btnLoading={createFormUpdateLoading}
        buttonName={employeeProfileInput?.employee_id ? "Update" : "Submit"}
      >
        <Row rowGap mb={20}>

          <Col sm={12} md={6}>
            <InputField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.date_of_birth.name)}

              valueSinc
              onKeyDown={e => e.preventDefault()}
              max={subtractYearsFromDate(employeeProfileInput.join_date, 18)}
            />
          </Col>
          <Col sm={12} md={6}>
            {/* <SelectField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.qualification.name)}
            /> */}
            <InputField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.qualification.name)}
            />
          </Col>
          <Col sm={12} md={6}>
            <SelectField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.blood_group.name)}

            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.gender.name)}
            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.marital_status.name)}

            />
          </Col>
          <Col sm={12} md={6}>
            <InputField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.alternative_phone.name)}
            />
          </Col>
          <Col sm={12} md={6}>
            <InputField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.personal_email.name)}
            />
          </Col>
          <Col sm={12} md={6}>
            <InputField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.guardian_name.name)}

            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.guardian_relationship.name)}

            />
          </Col>
        </Row>
      </Dialog>
      {/* Present Address Edit Modal */}
      <Dialog
        title="Present Address"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={Presentaddress}
        onClose={PresentaddressModalClose}
        onSubmit={() => handleClick(undefined, EMPLOYEE_PRESENT_ADDRESS_MODAL)}
        btnLoading={createFormUpdateLoading}
        buttonName={employeeProfileInput?.employee_id ? "Update" : "Submit"}

      >
        <Row rowGap>
          <Col sm={12} md={6}>
            <InputField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.present_address.name)}

            />
          </Col>

          <Col sm={12} md={6}>
            <InputField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.present_city.name)}

            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.present_state.name)}
              options={stateList}
            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.present_country.name)}
              value={"India"}
            />
          </Col>

          <Col sm={12} md={6}>
            <InputField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.present_pincode.name)}

            />
          </Col>

          {/* <Col sm={12} md={6}>
            <InputField
              fullWidth
              label="Location"
              placeholder="Type Here..."
              type="text"
            />
          </Col> */}

          <Col sm={12} md={6}>
            <InputField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.present_landmark.name)}

            />
          </Col>
        </Row>
      </Dialog>
      {/* Permanent Address Edit Modal */}
      <Dialog
        title="Permanent Address"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={Permanentaddress}
        onClose={PermanentaddressModalClose}
        onSubmit={() => handleClick(undefined, EMPLOYEE_PERMANENT_ADDRESS_MODAL)}
        btnLoading={createFormUpdateLoading}
        buttonName={employeeProfileInput?.employee_id ? "Update" : "Submit"}
      >
        <Row rowGap>
          <Col sm={12} md={6}>
            <InputField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.permanent_address.name)}

            />
          </Col>

          <Col sm={12} md={6}>
            <InputField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.permanent_city.name)}

            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.permanent_state.name)}
              options={stateList}
            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.permanent_country.name)}
              value={"India"}
            />
          </Col>

          <Col sm={12} md={6}>
            <InputField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.permanent_pincode.name)}
            />
          </Col>

          {/* <Col sm={12} md={6}>
            <InputField
              fullWidth
              label="Location"
              placeholder="Type Here..."
              type="text"
            />
          </Col> */}

          <Col sm={12} md={6}>
            <InputField
              {...getInputFieldProps(EMPLOYEE_FORM_FIELDS.permanent_landmark.name)}


            />
          </Col>
        </Row>
      </Dialog>
    </>
  )
}

export default ProfileDialog